import { render, staticRenderFns } from "./SidebarTeacher.vue?vue&type=template&id=68deeac5&scoped=true"
import script from "./SidebarTeacher.vue?vue&type=script&lang=js"
export * from "./SidebarTeacher.vue?vue&type=script&lang=js"
import style0 from "./SidebarTeacher.vue?vue&type=style&index=0&id=68deeac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68deeac5",
  null
  
)

export default component.exports